import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IMAGES } from "../../utils/images";
import { NavItem_Course } from "../../utils/navBarConfig";
import NavbarCourseCard from "../../reusable/NavbarCourseCard";
import "../../Styles/DashboardNavbar.css";
import { OVERALL_COURSES } from "../../utils/constants";

const DashboardNavbar = ({setDashDropdown}) => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [courseState, setCourseState] = useState(0);
  const [showRequestCallback, setShowRequestCallback] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [filtered_list, setFiltered_list] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  // Get user data from localStorage on component mount
  useEffect(() => {
    const userDataStr = localStorage.getItem("user");
    if (userDataStr) {
      try {
        const userData = JSON.parse(userDataStr);
        setUserData(userData);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  // Handle logout function
  const handleLogout = () => {
    // Clear authentication data
    sessionStorage.removeItem("authenticated");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    
    // Redirect to login page
    navigate("/signin");
  };

  //functions
  const handleMouseEnter = (index) => {
    setActiveDropdown(index);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const handleItemClick = () => {
    setActiveDropdown(null);
  };

  const handleBlur = () => {
    setTimeout(() => {
      setShowSearchResults(false);
    }, 300);
  };

  const nullText = () => {
    setSearchText("");
    setFiltered_list(null);
  };
  const handleChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    if (value === "") {
      setFiltered_list(null);
    } else {
      setFiltered_list(() =>
        OVERALL_COURSES.filter((item) =>
          item.title.toLowerCase().includes(value)
        )
      );
    }
  };
  return (
    <nav className="dash-navbar">
      <div className="dash-nav-left">
        <div className="dash-navbar-logo">
          <Link to="/">
            <img src={IMAGES.EDUTECH_LOGO} alt="Logo" className="logo-image" />
          </Link>
          <div className="nav-left-icons">
            {IMAGES.SEARCH_ICON && <img src={IMAGES.SEARCH_ICON} alt="Search" className="search-icon-mobile" />}
            <button
              onClick={() => setDashDropdown()}
              className="menu-icon"
            >
              <img src={IMAGES.MENU_ICON} />
            </button>
          </div>
        </div>
        <div className="navbar-items-dash">
          {NavItem_Course.map((item, index) => (
            <div
              key={index}
              className="dash-navbar-item"
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              <button className="nav-button-dash">
                {item.title}
                <img
                  src={IMAGES.CHEVRON_DOWN}
                  alt="Chevron"
                  className="chevron-image"
                />
              </button>
              {activeDropdown === index && (
                <div className="nav-dropdown-course-dash">
                  <div className="nav-dropdown-container-course">
                    <div className="dropdown-course">
                      <h1 className="dropdown-heading-course">{item.title}</h1>
                      {item.data.map((item, index) => (
                        <div
                          className={
                            index === courseState
                              ? "course-container-active"
                              : "course-container"
                          }
                          key={index}
                          onClick={() => setCourseState(index)}
                        >
                          <img
                            src={item.icon}
                            alt="Course Icon"
                            className="course-container-img"
                          />
                          <div className="course-container-name">
                            {item.name}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="overall-courses-container">
                      {item.data[courseState].courses.map((item, index) => (
                        <Link
                          to={item.link}
                          className="link-course"
                          onClick={handleItemClick}
                          key={index}
                        >
                          <NavbarCourseCard {...item} />
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="dash-search">
          <div className="dash-nav-search">
            {IMAGES.SEARCH_ICON && <img src={IMAGES.SEARCH_ICON} alt="Search" />}
            <input
              type="text"
              value={searchText}
              placeholder="Search for Courses"
              onFocus={() => {
                setShowSearchResults(true);
              }}
              onBlur={handleBlur}
              onChange={(e) => handleChange(e)}
            />
          </div>
          {showSearchResults && (
            <div className="search-results-dash">
              {filtered_list !== null ? (
                filtered_list.length > 0 ? (
                  filtered_list.map((item) => {
                    return (
                      <Link
                        to={item.link}
                        className="link"
                        key={item.title}
                        onClick={nullText}
                      >
                        <div className="single-search-result">{item.title}</div>
                      </Link>
                    );
                  })
                ) : (
                  <div className="no-search-result">No results Found</div>
                )
              ) : (
                <div className="start-search-result">
                  Start typing to Search Courses...
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="navbar-item-dash" onClick={handleLogout} style={{ cursor: 'pointer' }}>
        <img src={IMAGES.PROFILE_ICON} title={userData ? `${userData.fullName} (Click to logout)` : "Profile"} />
      </div>
    </nav>
  );
};

export default DashboardNavbar;
